import { useQuery } from '@tanstack/react-query';
import { dataSourceRoot, getDataSource } from '../data/dataSourceFactory';
import { toStudy, type Study } from '../data/types';
import type { StudyQuery } from '../data/DataSource';

/** Flat, one-row-per-study list for the worklist (sorting/paging happen client
 *  side over this set; server-side narrowing comes from the query filters). */
export function useStudies(query: StudyQuery = {}, enabled = true) {
  return useQuery({
    queryKey: ['studies', dataSourceRoot(), query],
    queryFn: async (): Promise<Study[]> => {
      const datasets = await getDataSource().searchStudies(query);
      return datasets.map(toStudy).filter((s) => s.studyInstanceUID);
    },
    // GATED ON KNOWING THE WORKSPACE. The selected one arrives a tick after the
    // page mounts, and running once without it would list every workspace's
    // studies and then take most of them away — which reads as the filter being
    // broken rather than as loading.
    enabled,
  });
}
